export const environment = {
  production: true,
  // api: 'https://panel-operator-api-dev.azurewebsites.net/',
  api: 'https://panel-crm-api-stage.azurewebsites.net/',
  apiJsonDemo: 'https://panel-api-demo.my-building.net:3001/',
  filesUrl: 'https://paneloperatorfiles.blob.core.windows.net/assets/',
  localInstance: 'panelcrm',
  version: 'stage.1.3.3'
};
